import axios from "axios"
import { BASE_URL } from "@/constants/util"

export const fetchLoLChampions = async () => {
  try {
    const response = await axios({
      method: "GET",
      url: `${BASE_URL}game-resources/leagueoflegends/static-data/champions`,
    })
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/store/game/leagueoflegends/leagueoflegends.apis.js